// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__UWvuY","question":"Question_question__13DmO","description":"Question_description__2yCEQ"};